import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addCurriculumContentAsync,
  getAllCurriculumContentAsync,
  getCurriculumContentByIdAsync,
  updateCurriculumContentByIdAsync,
  updateCurriculumContentStatusAsync,
  masterCurriculumByPackageIdAsync,
  deleteStudyMaterialAsync,
  getCurriculumFilesAsync,
  uploadCurriculumAsync,
} from "./curriculumcontent.async";

const initialState = {
  curriculumContentLoader: false,
  getAllCurriculumContent: [],
  curriculumContentAdd: [],
  curriculumContentById: [],
  curriculumContentUpdate: [],
  curriculumContentStatus: [],
  masterCurriculumByPackageId: [],
  deleteCurriculumContent: [],
  getCurriculumBulk: [],
  contentBulkUpload: [],
};

export const curriculumContentSlice = createSlice({
  name: "Spoken English",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getAllCurriculumContentAsync.pending,
        addCurriculumContentAsync.pending,
        updateCurriculumContentByIdAsync.pending,
        getCurriculumContentByIdAsync.pending,
        updateCurriculumContentStatusAsync.pending,
        masterCurriculumByPackageIdAsync.pending,
        deleteStudyMaterialAsync.pending,
        getCurriculumFilesAsync.pending,
        uploadCurriculumAsync.pending
      ),
      (state) => {
        state.curriculumContentLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteStudyMaterialAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.deleteCurriculumContent = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllCurriculumContentAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.getAllCurriculumContent = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(masterCurriculumByPackageIdAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.masterCurriculumByPackageId = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(addCurriculumContentAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.curriculumContentAdd = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getCurriculumContentByIdAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.curriculumContentById = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(updateCurriculumContentByIdAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.curriculumContentUpdate = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(updateCurriculumContentStatusAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.curriculumContentStatus = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getCurriculumFilesAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.getCurriculumBulk = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(uploadCurriculumAsync.fulfilled),
      (state, action) => {
        state.curriculumContentLoader = false;
        state.contentBulkUpload = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getAllCurriculumContentAsync.rejected,
        addCurriculumContentAsync.rejected,
        updateCurriculumContentByIdAsync.rejected,
        getCurriculumContentByIdAsync.rejected,
        updateCurriculumContentStatusAsync.rejected,
        masterCurriculumByPackageIdAsync.rejected,
        deleteStudyMaterialAsync.rejected,
        getCurriculumFilesAsync.rejected,
        uploadCurriculumAsync.rejected
      ),
      (state, action) => {
        state.curriculumContentLoader = false;
      }
    );
  },
  reducers: {
    emptyCurriculumContent: () => initialState,
  },
});

export const { emptyCurriculumContent } = curriculumContentSlice.actions;

export default curriculumContentSlice.reducer;
